import { render, staticRenderFns } from "./AreaClip.vue?vue&type=template&id=555be125&scoped=true"
import script from "./AreaClip.vue?vue&type=script&lang=js"
export * from "./AreaClip.vue?vue&type=script&lang=js"
import style0 from "./AreaClip.vue?vue&type=style&index=0&id=555be125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555be125",
  null
  
)

export default component.exports